export const LAUNCH_DARKLY_CLIENT_ID_DEV = '6426f5a0415a00137b6d5e73';
export const LAUNCH_DARKLY_CLIENT_ID_STAGING = '6425e3459d3ec6134054af6a';
export const LAUNCH_DARKLY_CLIENT_ID_DEMO = '6425e717ff65b71370ef06ae';
export const LAUNCH_DARKLY_CLIENT_ID_PROD = '6425b25d6b408f12eff021bb';
export const LAUNCH_DARKLY_CLIENT_ID_GOV = '6716917425eb2b083f01ae21';
